import Icon from '../components/Icon.vue'

Icon.register({
  'plane-arrival': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M624 448c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-608c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h608zM44.8 205.7c-6.5-5.9-12.4-14.3-12.6-23.3l-0.2-101.8c0.2-10.9 10.4-18.7 20.7-15.9l39.7 10.8c5 1.4 9.1 5 11 9.9l27.6 67.9 102.2 27.8-47.9-164.2c-0.2-11.1 10.2-19.3 20.7-16.4l65.1 17.7c5.7 1.6 10.2 6.1 11.7 11.9l100.4 191.9 97.5 26.6c26.5 7.2 51.5 20.2 70.8 40 21.6 22.3 27.2 40.5 23.4 55-3.8 14.5-17.6 27.4-47.3 35.7-26.4 7.4-54.5 5.9-81-1.4l-287.6-78.4c-7.9-2.2-19.4-8.4-25.5-13.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/plane-arrival.js
// module id = 1643
// module chunks = 0